import Head from 'next/head';
import Link from 'next/link';
import Header from '../../components/Header';

export default function WaterCleanupPage() {
  const phoneNumber = "(630) 715-8829";
  const companyName = "Partners Plumbing Co.";
  const serviceName = "Emergency Water Cleanup";
  const serviceArea = "Kane County, Geneva, Saint Charles, South Elgin";

  return (
    <>
      <Head>
        <title>{`Emergency Water Cleanup Geneva, IL | Kane County Flood Cleanup | ${companyName}`}</title>
        <meta name="description" content={`Emergency water cleanup in Geneva, St Charles & Kane County, IL. Flood cleanup, water damage restoration, emergency water removal. Fast response. Call ${phoneNumber} immediately!`} />
        <meta name="keywords" content="emergency water cleanup, flood cleanup Kane County, water damage Geneva IL, water removal Kane County, emergency water cleanup Kane County, basement flooding Geneva" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="canonical" href="https://partnersinplumbing.com/services/water-cleanup" />
        <link rel="icon" href="/favicon.ico" />
      </Head>

      <div className="min-h-screen bg-white">
        <Header currentPage="/services/water-cleanup" phoneNumber={phoneNumber} companyName={companyName} />

        {/* Sticky Emergency Contact Button */}
        <div className="fixed bottom-6 right-6 z-50">
          <a 
            href={`tel:${phoneNumber}`} 
            className="bg-red-600 text-white px-6 py-3 rounded-full shadow-lg hover:bg-red-700 transition-colors font-bold text-lg animate-pulse"
          >
            🚨 Emergency Call
          </a>
        </div>

        {/* Hero Section */}
        <section className="bg-gradient-to-r from-red-800 to-red-900 text-white py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">
                Emergency Water Cleanup Services
              </h1>
              <p className="text-xl md:text-2xl text-red-100 mb-8 max-w-3xl mx-auto">
                Emergency water cleanup and damage restoration in {serviceArea}. Fast response to minimize damage and costs.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
                <a 
                  href={`tel:${phoneNumber}`} 
                  className="bg-yellow-500 text-slate-900 px-8 py-4 rounded-lg font-bold text-lg hover:bg-yellow-400 transition-colors animate-pulse"
                >
                  🚨 Emergency Call: {phoneNumber}
                </a>
                <Link 
                  href="/contact" 
                  className="bg-white text-slate-800 px-8 py-4 rounded-lg font-bold text-lg hover:bg-gray-100 transition-colors"
                >
                  📝 Request Emergency Help
                </Link>
              </div>
              <p className="text-red-200 text-sm">
                💧 Emergency Water Extraction | ⚡ Fast Response | 🛡️ Insurance Assistance
              </p>
            </div>
          </div>
        </section>

        {/* Emergency Services */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Emergency Water Cleanup Services</h2>
              <p className="text-xl text-gray-600">Immediate response to water emergencies throughout Kane County</p>
            </div>
            
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {[
                {
                  title: "Water Extraction",
                  description: "Professional water removal using industrial-grade equipment to prevent further damage"
                },
                {
                  title: "Flood Cleanup",
                  description: "Complete flood cleanup services including water removal and property restoration"
                },
                {
                  title: "Structural Drying",
                  description: "Advanced drying techniques to prevent mold growth and structural damage"
                },
                {
                  title: "Damage Assessment",
                  description: "Thorough damage assessment and documentation for insurance claims"
                },
                {
                  title: "Emergency Repairs",
                  description: "Immediate plumbing repairs to stop water source and prevent further damage"
                },
                {
                  title: "Emergency Response",
                  description: "Round-the-clock emergency response throughout Kane County and surrounding areas"
                }
              ].map((service, index) => (
                <div key={index} className="bg-red-50 p-6 rounded-lg shadow-md border-l-4 border-red-500">
                  <h3 className="text-xl font-semibold text-gray-900 mb-3">{service.title}</h3>
                  <p className="text-gray-600 mb-4">{service.description}</p>
                  <Link href="/contact" className="bg-red-600 text-white px-6 py-3 rounded-lg font-bold hover:bg-red-700 transition-colors inline-block">
                    Get Emergency Help
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-16 bg-red-800 text-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              Water Emergency? Call Now!
            </h2>
            <p className="text-xl text-red-100 mb-8 max-w-3xl mx-auto">
              Every minute counts in a water emergency. Our team provides immediate response throughout {serviceArea} to minimize damage and begin restoration. View all our <Link href="/services/emergency-plumbing-service" className="text-yellow-400 hover:text-yellow-300 font-semibold underline">emergency plumber services in Kane County</Link>.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href={`tel:${phoneNumber}`} 
                className="bg-yellow-500 text-slate-900 px-8 py-4 rounded-lg font-bold text-lg hover:bg-yellow-400 transition-colors"
              >
                Emergency: {phoneNumber}
              </a>
              <Link 
                href="/contact" 
                className="bg-white text-slate-800 px-8 py-4 rounded-lg font-bold text-lg hover:bg-gray-100 transition-colors"
              >
                Request Emergency Service
              </Link>
            </div>
          </div>
        </section>
      </div>
    </>
  );
} 